import React from 'react';

import { Control, Controller } from 'react-hook-form';

import SelectWithCreate from 'components/common/SelectWithCreate/SelectWithCreate';
import { useSelectWithCreateHook } from 'components/common/SelectWithCreate/SelectWithCreateHook';

import { tagsToOptions } from 'components/Dashboards/Reporting/ReportSettingsModal/components/UpdateReportTags/UpdateReportTags.utils';
import {
    UseReportTagsSelectWithCreateProvider,
    useReportTagsSelectWithCreateProvider,
} from 'components/Dashboards/Reporting/_common/ReportTagsSelectWithCreate/ReportTagsSelectWithCreate.provider';
import { FormValues } from 'components/widgets/ReportsHome/ReportsTemplates/components/CreateReportFromTemplateModal/CreateReportFromTemplateModal.types';

interface Props {
    handleChange: (value: ISelectOption<number>[]) => void;
    control: Control<FormValues, any, FormValues>;
}

export const ReportTagsSelectWithCreate = ({ handleChange, control }: Props) => {
    const { inputValue, onInputChange, onChange } = useSelectWithCreateHook<number>({
        onChangeCallback: (value) => handleChange(value),
    });
    const { api }: { api: UseReportTagsSelectWithCreateProvider['api'] } = useReportTagsSelectWithCreateProvider();

    const tagsAsOptions = tagsToOptions(api.getReportsTags.data ?? []);

    return (
        <Controller
            render={({ field }) => (
                <SelectWithCreate<number>
                    {...field}
                    options={tagsAsOptions}
                    id={'cardModalTags'}
                    placeholder={'Select Tags...'}
                    isMulti={true}
                    isClearable={true}
                    onChange={onChange}
                    inputValue={inputValue}
                    onInputChange={onInputChange}
                    value={tagsToOptions(field.value)}
                    isLoading={api.getReportsTags.isLoading ?? false}
                />
            )}
            control={control}
            name={'selectedTags'}
        />
    );
};
